export default function (url: string) {
  return url
    .replace(
      /(utm_.*&|etext.*&|yandex_geo.*&|yadclid.*&|yadordid.*&|ymclid.*&|rb_clickid.*&|gclid.*&|fbclid.*&|[&|?]utm_.*$|[&|?]etext.*$|[&|?]yandex_geo.*$|[&|?]yadclid.*$|[&|?]yadordid.*$|[&|?]ymclid.*$|[&|?]yclid.*$|[&|?]ysclid.*$|[&|?]rb_clickid.*$|[&|?]gclid.*$|[&|?]fbclid.*$|#.*|\/)/g,
      '',
    )
}
